import { jwtDecode } from 'jwt-decode';

// Cancellation/remount identity only. Decoding never grants authorisation;
// every operation still passes through the authenticated backend. Expiry/iat
// rotate during refresh and must not discard the existing scene draft.
export function workspaceAccountScope(auth) {
  const user = auth?.userInfo?._id || auth?.userInfo?.id || auth?.userInfo?.email || '';
  if (!auth?.token) return JSON.stringify(['no-session',user]);
  try {
    const claims=jwtDecode(auth.token);
    return JSON.stringify(['session',claims.id || claims.sub || user,claims.sid || 'legacy',claims.securityVersion || 0]);
  } catch {
    // Opaque/invalid development tokens cannot be used for server admission.
    return JSON.stringify(['opaque',user,auth.token]);
  }
}

export function currentWorkspaceAccountScope() {
  return workspaceAccountScope({ token: sessionStorage.getItem('doar_token') });
}
